module.exports = __webpack_public_path__ + "img/main_card.1d517792.png";